import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    heigth: '66px',
    margin: 0,
    marginBottom: '0.75rem',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  hero: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },

  title: {
    fontFamily: 'Sora',
    fontWeight: '400',
    fontSize: '34px',
    lineHeight: '42px',
    color: `${theme.palette.secondary.contrastText} !important`,
  },

  subtitle: {
    paddingTop: '2px',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '14.5px',
    lineHeight: '20px',
    color: `${theme.palette.secondary.contrastText} !important`,
    opacity: 0.6,
  },

  button: {
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.primary.main,
    width: 'auto',
    margin: 0,
    padding: '0 1.375rem',
    fontFamily: 'Sora',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '46px',
    color: `${theme.palette.primary.contrastText} !important`,
    textDecoration: 'none',
  },
}))

export { useStyles }
